<template>
  <div
      class="activity"
      :class="{
      'activity-top': showDescription,
      'activity-simple': !showDescription
    }"
  >
    <b-row>
      <b-col class="activity__title">
        {{ activity.name }}
      </b-col>
      <b-col class="activity__date">
        {{ activity.date | formatDateAndTime }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <vue-markdown
            class="activity__description"
            :source="activity.description"
            :strict="false"
        />
      </b-col>
      <b-col cols="5">
        <br/>
        <table class="table table-bordered table--price">
          <tr>
            <th>Prix membre</th>
            <td>{{ activity.price.priceMember | formatMoney }}</td>
          </tr>
          <tr v-if="activity.membersOnly === false">
            <th>Prix régulier</th>
            <td>{{ activity.price.priceRegular | formatMoney }}</td>
          </tr>
          <tr>
            <th>Prix mineur membre</th>
            <td>{{ activity.priceMinor.priceMember | formatMoney }}</td>
          </tr>
          <tr v-if="activity.membersOnly === false">
            <th>Prix mineur régulier</th>
            <td>{{ activity.priceMinor.priceRegular | formatMoney }}</td>
          </tr>
          <template v-if="activity.surplusNonResident">
            <tr>
              <th>Surplus* membre</th>
              <td>
                {{ activity.surplusNonResident.priceMember | formatMoney }}
              </td>
            </tr>
            <tr v-if="activity.membersOnly === false">
              <th>Surplus* régulier</th>
              <td>
                {{ activity.surplusNonResident.priceRegular | formatMoney }}
              </td>
            </tr>
          </template>
          <template v-if="activity.surplusNonResidentMinor">
            <tr>
              <th>Surplus* si mineur</th>
              <td>
                {{ activity.surplusNonResidentMinor.priceMember | formatMoney }}
              </td>
            </tr>
            <tr v-if="activity.membersOnly === false">
              <th>Surplus* régulier</th>
              <td>
                {{ activity.surplusNonResidentMinor.priceRegular | formatMoney }}
              </td>
            </tr>
          </template>
          <tr>
            <th>Limite d'inscriptions</th>
            <td>{{ activity.registrationMaximum }}</td>
          </tr>
        </table>
        <p style="text-align: left; margin-top: 5px; margin-bottom: 10px; padding-top: 0; font-size: 10px;">
          * Surplus uniquement si vous n'habitez pas la ville de Québec.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <template v-if="isConnected && activity.acceptRegistrations === true">
          <b-button
              variant="primary"
              @click="showRegisterModal"
              style="width: 100%"
          >
            Inscription à l'activité
          </b-button>
        </template>
        <template v-else-if="activity.acceptRegistrations === false">
          <b-button  variant="outline-secondary" style="width: 100%">
            Les inscriptions ne sont pas encore activés
          </b-button>
        </template>
        <template v-else>
          <b-button  variant="outline-secondary" style="width: 100%" @click="$router.push({ name: 'DevenirMembrePage'});">
            Devenir membre
          </b-button>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ActivityRegistrationModal from './Activite_Inscription';
  import { mapGetters } from 'vuex';

  export default {
    name: 'activity-entry',
    props: {
      activity: {
        type: Object
      },
      showDescription: {
        type: Boolean,
        default: () => true
      }
    },
    computed: {
      ...mapGetters({
        isConnected: 'account/isConnected'
      })
    },
    methods: {
      async showRegisterModal() {
        // Ask the user to confirm and select the member to be registered.
        await this.$store.dispatch('members/fetchMembers');
        // Show modal
        this.$modal.show(
          ActivityRegistrationModal,
          {
            activityId: this.activity.id
          },
          {
            height: 'auto',
            minHeight: 300,
            name: 'activity-registration-modal',
            root: this.$root
          }
        );
      }
    }
  };
</script>

<style lang="scss">
.activity-top {
  text-align: center;
}

.activity-simple {
  text-align: left !important;
}

.activity {
  &__title,
  &__date {
    font-size: 1rem;
    color: #b1661b;
    font-family: Georgia, "Times New Roman", Times, serif;
  }

  &__title {
    text-align: left;
  }

  &__date {
    text-align: right;
  }

  &__description {
    padding-top: 20px;
    padding-bottom: 20px;

    * {
      margin: 0;
      padding: 0;
      border: 0;
      font: inherit;
      vertical-align: baseline;
    }

    h1, h2, h3, h4, h5, h6 {
      text-align: left;
    }

    h1 {
      font-size: 1.2rem !important;
      padding-bottom: 15px;
      padding-top: 15px;
    }

    h2 {
      font-size: 1rem !important;
      padding-bottom: 10px;
      padding-top: 10px;
    }

    h3 {
      font-size: 0.6rem !important;
      margin: 2rem 0;
      padding-bottom: 10px;
    }

    h4 {
      font-size: 0.4rem !important;
      padding-bottom: 5px;
    }

    h5 {
      font-size: 0.2rem !important;
      padding-bottom: 5px;
    }

    p {
      margin-bottom: 10px;
      text-align: justify;
      font-family: Verdana, Arial, Helvetica, sans-serif;
      font-size: 12px;
      line-height: 1.5em;
      color: #4d4d4d;
    }
  }
}
</style>
